export const EDITOR_UI = {
  PAD: 8,
  BTN_BOX: 80,
};

export const AI_CONFIG = {
  TEMPERATURE: 0.7,
  MODEL_ID: 14,
};
